import { MatSnackBar } from "@angular/material/snack-bar";

export namespace response {
    let errorsMsg:any = {
        "UNKOWN_ENTITY": "Entitat desconeguda",
        "ADD_DATA_TRANSACTION_ERROR": "No s'ha pogut afegir informació a la transacció",
        "ADD_DOCUMENTS_TRANSACTION_ERROR": "No s'ha pogut afegir documents a la transacció del MUX",
        "ADD_ENTITIES_TRANSACTION_ERROR": "No s'ha pogut afegir entitats a la transacció del MUX",
        "ALREADY_EXISTS": "Ja existeix",
        "APPLICATION_NOT_FOUND": "No s'ha trobat l'aplicació",
        "ATTACHMENT_NOT_FOUND": "No s'ha trobat l'adjunt",
        "AUTHENTICATION_HEADER_ERROR": "La capçalera d'autenticació és errònia",
        "CLONE_NOT_POSIBLE_IF_EXISTS_DRAFT_OR_REVIEW": "No es pot duplicar si existeix un esborrany o un tràmit pendent de validar",
        "CLOSE_SERVICE_INSTANCE_NOT_ALLOWED": "No pots tancar l'expedient",
        "CODE_ALREADY_EXIST": "Aquest codi ja existeix",
        "CREATE_DESAL_DOCUMENT_ERROR": "No s'ha pogut crear el document al DESAL",
        "CREATING_APPOINTMENT_ERROR": null,
        "DELETE_ALL_FAIL_CATALEG": "No s'ha pogut esborrar el Catàleg",
        "DELETE_FAIL_CATALEG": "No s'ha pogut esborrar el Catàleg",
        "DELETE_FAIL_NOT_FOUND_CATALEG": "No s'ha trobat el Catàleg per esborrar",
        "DOC_NOT_FOUND": "No s'ha trobat el document",
        "DOCUMENT_LOAD_ERROR": "No s'ha pogut carregar el document",
        "DOWNLOAD_ARCHIVE_AS_STRING_ERROR": "No s'ha pogut descarregar el document",
        "DOWNLOAD_DESAL_FILE_ATTACHMENTS_ERROR": "No s'ha pogut descarregar els documents de l'expedient",
        "DOWNLOAD_DESAL_FILE_ERROR": "No s'ha pogut descarregar el document",
        "DOWNLOAD_DOCUMENT_FILE_ERROR": "No s'ha pogut descarregar el document",
        "DUPLICATE_PROPERTY_NOT_ALLOWED": "No pots duplicar la propietat",        
        "ENTITY_NOT_FOUND": "No s'ha trobat l'entitat",
        "PROMOTER_ENTITY_NOT_FOUND":"No s'ha trobat l'entitat prestadora",
        "RECEPTOR_ENTITY_NOT_FOUND":"No s'ha trobat l'entitat destinatària",
        "ENTITY_REFERENCE_IS_NULL": "No s'ha especificat la referència a l'entitat",
        "ENTITY_SARCAT_DEFAULT_IN_USE": "L'entitat de SARCAT està assignada com a destinatària de serveis",
        "ENTITY_SARCAT_NOT_FOUND": "No s'ha trobat l'entitat de SARCAT",
        "ENTITY_SARCAT_UNIQUE": "L'entitat de SARCAT ha de ser única",
        "ENTITY_TYPE_NOT_EXISTS": "No existeix el tipus d'entitat",
        "ERROR_AQUIRE_LOCK": "No s'ha pogut bloquejar",
        "ERROR_CHECKING_OBJECT_EXISTENCE": null,
        "ERROR_INIT_PROCEDURE": "No s'ha pogut iniciar el tràmit",
        "ERROR_LOAD_INFO_TO_FORM_HEADER": "No s'ha pogut carregar la capçalera del formulari",
        "ERROR_LOAD_INFO_TO_FORM_SECTION": "No s'ha pogut  carregar la secció del formulari",
        "ERROR_LOADING_FORM_SCRIPT": "No s'ha pogut carregar l'script del formulari",
        "ERROR_NOT_ALL_ATTACHED_DOCS_UPLOADED_TO_DESAL": "Alguns documents no s'han pujat al DESAL",
        "ERROR_PROCEDURE_TO_VALIDATE": "No s'ha pogut validar el tràmit",
        "ERROR_SEND_TO_PROCESSING_PROCEDURE": null,
        "ERROR_STORING_FORM": "No s'ha pogut gravar el formulari",
        "ERROR_STORING_FORM_SCRIPT": "No s'ha pogut gravar l'script del formulari",
        "ERROR_STORING_SECTION_FORM": "No s'ha pogut gravar la secció del formulari",
        "ERROR_VALIDATING": "No s'ha pogut validar el formulari",                
        "EXECUTION_SCRIPT_ERROR": "No s'ha pogut executar l'script",
        "EXISTS_IDCENTER": "Ja existeix l'ID centre",
        "EXISTS_INTANCES": "S'han trobat instàncies",
        "EXISTS_NOT_PROCESSED_PROCEDURE_INSTANCE": "No s'ha pogut realitzar perquè hi ha instàncies de tràmits pendents",
        "EXISTS_PROCEDURE_INSTANCE": "S'ha trobat una instància de tràmit",
        "EXISTS_PROCEDURES": "No s'ha pogut realitzar perquè hi ha tràmits",
        "FILES_ERRORS": "S'han trobat errors en els fitxers del DESAL",        
        "IDENTIFIER_NO_BELONGS_TO_ENTITY": "Aquest identificador no pertany a l'entitat",        
        "INIT_PROCESS_KO": "No s'ha pogut iniciar el procés de signatura",        
        "INVALID_KEY": "La clau no és vàlida",
        "JSON_MALFORMED": "El format del JSON és incorrecte",
        "MALFORMED_FORM": "El formulari és incorrecte",
        "MALFORMED_FORM_HEADER": "La capçalera del formulari és incorrecta",
        "MALFORMED_JSON_FORM": "El format del JSON és incorrecte",
        "MISSING_APPLICATION": "No s'ha trobat l'aplicació",
        "MISSING_GLOBAL_INBOX": "No s'ha trobat la bústia global",
        "MISSING_PARAMETERS": "No s'han trobat els paràmetres",
        "MISSING_SECTION_METADATA": "No s'ha trobat la metadada de la secció",
        "MISSING_SECTION_VALUE": "No s'ha trobat la informació de la secció",
        "MISSING_SERVICE_CODE": "No s'ha trobat el codi del servei",
        "MUX_SARCAT_DATA_PROMOTER_ENTITY": "Error en l'entitat emissora de SARCAT: no s'ha pogut configurar la unitat organitzativa al servei",
        "MUX_SARCAT_DATA_PROMOTER_ENTITY_TYPE": "Error en el tipus d'entitat emissora de SARCAT: no s'ha pogut configurar la unitat organitzativa al servei",
        "MUX_SARCAT_DATA_RECEPTOR_ESPECIFIC": "Error en l'entitat receptora de SARCAT",
        "MUX_SARCAT_DATA_RECEPTOR_GENERIC": "Error en l'entitat receptora genèrica de SARCAT",
        "MUX_SARCAT_TGEN_DATA_PROMOTER": "Error amb la TGEN emissora de SARCAT",
        "MUX_SARCAT_TGEN_DATA_RECEPTOR": "Error amb la TGEN receptora de SARCAT",
        "MUX_SARCAT_TGEN_DATA_SUB_ENS_PROMOTER": "Error amb la TGEN emissora de SARCAT de la subentitat",
        "MUX_SARCAT_TGEN_DATA_SUB_ENS_RECEPTOR": "Error amb la TGEN emissora de receptora de la subentitat",
        "PROCEDURE_INSTANCE_NOT_FOUND": "No s'ha trobat el tràmit",
        "NO_GENERIC_OU_FOUND": "No s'ha trobat la UO principal",
        "NO_PACKAGE_PRESENT": "No s'ha trobat el paquet",
        "NO_SERVICE_PROMOTER_FOUND": "No s'ha trobat el servei emissor",
        "NO_SIGNATURE_PRESENT": "No s'ha trobat la signatura",
        "NO_SUCH_ALGORITHM": "No s'ha trobat l'algorisme",
        "NOT_AVAILABLE_STATE": "L'estat no està disponible",
        "NOT_IN_DATES": "Fora de dates",
        "NOT_OFFERED": "No disponible",
        "NOT_PROMOTER_FOUND": "No s'ha trobat l'emissor",
        "NOT_SUPPORTED_ALGORITHM": "L'algorisme no és compatible",
        "OU_DISABLE_FORBIDDEN_EXISTS_AS_SARCAT_OU": "La UO està en ús a SARCAT",
        "OU_EXISTS_ON_PROCEDURES": "La UO està en ús",
        "OU_NOT_FOUND": "No s'ha trobat la UO",
        "PASSWORD_IN_HISTORY": "Ja has fet servir aquesta contrasenya",
        "PASSWORD_NOT_VALID": "La contrasenya no és vàlida",
        "PROCEDURE_HEADER_NOT_AVAILABLE_ON_ENTITY": "La capçalera del tràmit no està disponible per a l'entitat",
        "PROCEDURE_HEADER_NOT_FOUND": "No s'ha trobat la capçalera del tràmit",
        "PROCEDURE_INSTANCE_ID_NOT_FOUND": "No s'ha trobat la instància del tràmit",
        "PROCEDURE_NOT_FOUND": "No s'ha trobat la configuració del tràmit",
        "PROCEDURE_TO_CLONE_NOT_FOUND": "No s'ha trobat la configuració del tràmit per a clonar",
        "PROPERTY_CORRUPTED_MORE_THAN_ONE_WHEN_NOT_ALLOWED": "Propietat corrupta. Hi ha més d'una propietat amb el mateix nom.",
        "PUT_FAIL_CATALEG": "No s'ha pogut carregar en el Catàleg",
        "QUOTA_INBOX_EXCEEDED": "Has arribat al màxim de bústies",
        "READING_SOURCE_ERROR": "No s'ha pogut crear el SHA (Algorisme de Hash Segur)",
        "REAIDNG_BODY": "No s'ha pogut llegir la resposta",
        "REINDEX_IN_PROGRESS": "Reindexació en progrés",        
        "REMOVE_OLD_NOTIFICATION_IN_PROGRESS": "Esborrant notificacions antigues",
        "REQUEST_ERROR": null,
        "SERVICE_NOT_FOUND": "No s'ha trobat el servei",
        "SERVICE_SARCAT_NOT_FOUND": "No s'ha trobat el SARCAT",
        "SERVICE_SARCAT_UNIQUE": "El SARCAT ha de ser únic",
        "SIGNATURE_EVIDENCE_MALFORMED": "No s'ha pogut validar l'evidència de signatura",
        "SIGNATURE_RESULT_KO": "No s'ha pogut signar",
        "SIZE_MISSTMATCH": "No coincideixen els tamanys",
        "START_PROCESS_KO": "No s'ha pogut iniciar la tramitació",
        "STATE_IS_NULL": "Estat no especificat",
        "TASK_NOT_EXISTS": "No existeix la tasca",
        "TGEN_SERVICE_NOT_FOUND": "No s'ha trobat el servei de PGEN",
        "TYPE_IS_NULL": "Tipus no especificat",
        "UNKNOW_INE10": "Codi oficial estadístic desconegut",
        "UNKNOWN_APPLICATION": "Aplicació desconeguda",
        "UNKNOWN_ENTITY": "Entitat desconeguda",
        "UNKNOWN_PROCEDURE_HEADER": "Configuració de tràmit desconeguda",
        "UNKNOWN_PROCEDURE_INSTANCE": "Instància de tràmit desconeguda",
        "UNKNOWN_PROPERTY": "Propietat desconeguda",
        "UNKNOWN_SARCAT": "SARCAT desconegut",
        "UNKNOWN_SERVICE": "Servei desconegut",
        "UNKNOWN_SERVICE_INSTANCE": "Expedient desconegut",
        "UNKNOWN_USER": "Usuari desconegut",
        "UNKOWN_PROCEDURE_INSTANCE": "Tràmit desconegut",
        "UNSUPPORTED_ENCODING": "Codificació no compatible",
        "UPLOAD_DOCUMENT_DESAL_ERROR": "No s'ha pogut pujar el document al DESAL",
        "UPLOAD_ERROR": "Error de càrrega",
        "UPLOAD_TICKET_TRANSACTION_ERROR": "No s'ha pogut pujar el tiquet al DESAL",
        "USER_NOT_BELONG_TO_ENTITY": "L'usuari no pertany a l'entitat",
        "USER_NOT_FOUND": "No s'ha trobat l'usuari",
        "UNKNOWN_ERROR": "Error desconegut",
        "VALIDATION_SCRIPT_FILE_NOT_FOUND": "No s'ha trobat el fitxer de validació",
        "TASK_CREATION_ERROR": "No s'ha pogut crear la tasca",
        "SERVICE_OR_PROCEDURE_NOT_PUBLISHED": "El servei o tràmit no està publicat",
        "MISSING_PROMOTER_ENTITY": "No s'ha trobat l'entitat emissora",
        "MISSING_PROMOTER_ENTITY_TYPE": "No s'ha trobat el tipus d'entitat emissora",
        "MISSING_RECEPTOR_ENTITY_TYPE": "No s'ha trobat el tipus d'entitat receptora",
        "ONLY_PROMOTER_CAN_INIT_PROCEDURE": "Només l'emissor pot iniciar el tràmit",
        "ONLY_RECEPTOR_CAN_INIT_PROCEDURE": "Només el receptor pot iniciar el tràmit",
        "SNS_ERROR": "Error a la notificació",
        "MALFORMED_URL_ERROR": "Format d'URL incorrecte",
        "MALFORMED_REQUEST_ERROR": "La petició és incorrecta",
        "PROCEDURE_INSTANCE_UNKOWN": "Instància de tràmit desconeguda",
        "EXECUTE_MUX_TRANSACTION_ERROR": "No s'ha pogut executar la transacció del MUX",
        "NOT_SETTLE_TRUE_MUX_TRANSACTION_ERROR": "L'entitat de registre ha retornat un error. Consulteu el MUX per conèixer els detalls",
        "MUX_ERROR": "Error al MUX",
        "DB_ERROR": "Error de base de dades",
        "ADD_DATA_MUX_TRANSACTION_ERROR": "No s'han pogut afegir les metadades a la transacció del MUX",
        "SIGNATURE_APPLET_ERROR": "Error a l'eina de signatura",
        "PARENT_PROCEDURE_INSTANCE_ID_NOT_FOUND": "No s'ha trobat l'identificador d'instància del tràmit pare",
        "ENTITY_NOT_PRESENT_ON_SERVICE_INSTANCE": "No s'ha trobat l'entitat de l'expedient",
        "PARENT_SERVICE_MISMATCH": "El servei pare no correspon",
        "UNKNOWN_PARENT_PROCEDURE": "Tràmit pare desconegut",
        "PROCEDURE_PARENT_INCORRECT": "Tràmit pare incorrecte",
        "MALFORMED_FORM_ERROR": "El formulari no és correcte",
        "TGEN0001_PROCEDURE_HEADER_NOT_FOUND": "No s'ha trobat la configuració de la PGEN",
        "TOKEN_EXPIRED": "Testimoni caducat",
        "UNKOWN_SUBJECT": "Assumpte desconegut",
        "FAIL": "Error",
        "NO_THEME_FOUND": "No s'ha trobat el tema",
        "NO_CALLBACK_FOUND": "No s'ha trobat la crida de retorn",
        "UNKNOWN_THEME": "Tema deconegut",
        "UNKNOWN_PROCEDURE": "Tràmit desconegut",
        "UNKNOWN_SERVICE_CODE": "Servei desconegut",
        "UNKNOWN_PROCEDURE_CODE": "Codi del tràmit desconegut",
        "UNKNOWN_PROCEDURE_TYPE": "Tipus de tràmit desconegut",
        "VIEW_UNKOWN": "Vista desconeguda",
        "SERVICE_CODE_IS_REQUIRED": "El codi de servei és obligatori",
        "UNKNOWN_PROCEDURE_INSTANCE_CODE": "Codi d'instància de tràmit desconegut",
        "PROCEDURE_INSTANCE_MUST_BE_IN_DRAFT_STATE": "L'instància del tràmit ha d'estar en esborrany",
        "ARCHIVE_NOT_FOUND": "No s'ha trobat l'arxiu",
        "FORM_OR_ATTACHMENT_IS_REQUIRED": "El formulari o adjunt és obligatori",
        "PROCEDURE_NOT_AVAILABLE_TO_PROCESS": "No hi ha cap tràmit disponible per tramitar.",
        "PROCEDURE_INSTANCE_NOTFOUND": "No s'ha trobat la instància de tràmit",        
        "MISSING_INFO": "Falta informació",
        "INE10_NOT_VALID": "El codi oficial estadístic no és vàlid",
        "FILE_SIZE_TOO_BIG": "L'arxiu és masa gran",
        "ARCHIVE_NAME_NOT_VALID": "El nom de l'arxiu no és vàlid",
        "ARCHIVE_FORMAT_NOT_VALID": "El format de l'arxiu no és vàlid",
        "WAITING_ANTIVIRUS_CHECK": "Esperant la comprovació d'antivirus",
        "NO_FILE_FOUND": null,
        "FILE_UUID_NOT_VALID": "L'identificador únic universal de l'expedient no és vàlid",
        "WRONG_CONFIG": "Configuració incorrecta",
        "INE10_CODE_NOT_VALID": "El codi del camp codi oficial estadístic no és vàlid",
        "ARCHIVE_WITH_VIRUS": "L'arxiu conté un virus",
        "UNKNOWN_ARCHIVE_ERROR": "S'ha trobat un error desconegut de l'arxiu",
        "MALFORMED_FORM_NO_SECTION_NAME_DEFINED": "No s'ha definit cap nom de secció al formulari",
        "MALFORMED_JSON_FORM_SECTION_VALUE": "El nom de secció del formulari no és vàlid",
        "UNKNOWN_SECTION_IDENTIFIER": "L'Identificador de la secció és desconegut",
        "MALFORMED_SECTION_DEF_FORM": "La secció del formulari no és correcta",
        "SERVICE_CODE_IS_NULL": "No s'ha especificat el codi de servei",
        "PROCEDURE_CODE_IS_NULL": "No s'ha especificat el codi de tràmit",
        "VERSION_IS_NULL": "No s'ha especificat la versió",
        "ARCHIVE_NAME_IS_NULL": "No s'ha especificat el nom de l'arxiu",
        "ARCHIVE_FORMAT_IS_NULL": "No s'ha especificat el format de l'arxiu",
        "SIZE_IS_NULL": "No s'ha especificat el tamany",
        "UUID_DESAL_ARCHIVE_IS_NULL": "No s'ha especificat l'identificador únic universal del DESAL ",
        "YOU_DIDNT_SAY_THE_MAGIC_WORD": "No has escrit la paraula màgica",
        "ERROR_SAVING_SIGNATURE_INTO_DB": "No s'ha pogut guardar la signatura a la base de dades",
        "ADD_DATA_TGEN_MUX_TRANSACTION_ERROR": "No s'ha pogut afegir la informació de la PGEN a la transacció del MUX",
        "MALFORMED_OBJECT": "Objecte incorrecte",
        "ERROR": "Error",
        "NOT_SAME_PACKAGE": "Paquet diferent",
        "NOT_PROCEDURE_TO_COPY": "No hi ha cap tràmit per copiar",
        "PERMISION_DENIED": "Permís denegat",
        "HAVE_SECTIONS": "Hi ha seccions",
        "MISSING_FORM": "Falta el formulari",
        "MISSING_SECTIONS": "Falta la secció",
        "SOURCE_S_NOT_FOUND": "No s'ha trobat el servei d'origen",
        "DEST_S_NOT_FOUND": "No s'ha trobat el servei de destinació",
        "USER_ENTITY_NOT_FOUND": "No s'ha trobat l'entitat de l'usuari",
        "USER_ENTITY_AUTO_REMOVE_FORBIDEN": "No es pot esborrar l'entitat de l'usuari",
        "TOO_BIG_FILE_CODE": "El fitxer és massa gran",
        "UNKNOWN_APP": "Aplicació desconeguda",
        "AA_NOT_FOUND": "No s'ha trobat l'accés a l'aplicació",
        "MALFORMED_LANDING_PAGE_URL": "La URL de la pàgina d'inici no és correcta",
        "INIT_MUX_TRANSACTION_ERROR": "No s'ha pogut iniciar la transacció del MUX",
        "SERVICE_INSTANCE_CLOSED": "Expedient tancat",
        "TASK_CONTEXT_NOT_EXISTS": "El context de la tasca no existeix",
        "DIGEST_HASH_ERROR": "No s'ha trobat la funció criptogràfica",
        "RESUME_MISSING_GENERIC_FORM_HASH": "No s'ha trobat el resum de la funció criptogràfica",
        "INCORRECT_PASSWORD":"La contrasenya no és correcta",
        "SERVICE_INSTANCE_CODE_MISSING":"No s'ha trobat el codi de la instància de servei",
        "MALFORMED_LANDING_TICKET_PAGE_URL":"No és correcte la URL del tiquet",
        "CREATE_DESAL_FILE":"No s'ha pogut crear l'expedient a DESAL",
        "DOCUMENT_NUMBER_MISMATCH":"La quantitat de fitxers pujats a DESAL no coincideix amb la indicada a la base de dades",
        "MISSING_ARCHIVE":"Falten fitxers per pujar a DESAL",
        "SAVE_ATTACHED_DOCS":"No s'han pogut actualitzar les dades de DESAL a la base de dades.",
        "MODIFY_DESAL_DOCUMENT":"No s'han pogut actualitzar els documents del DESAL",
        "TICKET_NOT_FOUND":"No s'ha trobat el tiquet",
        "RESUME_NOT_FOUND":"No s'ha trobat el resum",
        "TICKET_NOT_UPLOAD_TO_DESAL":"El tiquet no s'ha pujat encara a DESAL",
        "RELIVE_MUX_TRANSACTION_ERROR":"No s'ha pogut reprendre la transacció del MUX",
        "PUT_TICKET_IN_TRANSACTION":"No s'ha pogut pujar el tiquet a la transacció del MUX",
        "NEED_RETRY_MUX_TRANSACTION_ERROR":"L'entitat de registre encara no ha retornat el número de registre (temps excedit de lectura)",
        "UPDATE_REGISTER_TASK_CONTEXT_MUX_TRANSACTION_ERROR":"No s'ha pogut afegir el registre a la base de dades",
        "ENTITY_SARCAT_OFFER_UNIQUE":"L'entitat receptora té més d'un ID centre seleccionat per aquest servei",
        "ENTITY_SARCAT_DEFAULT_NOT_FOUND":"No s'ha trobat l'ID centre de l'entitat",
        "ENTITY_SARCAT_DEFAULT_UNIQUE":"L'entitat té més d'un ID de centre configurat per defecte",
        "ENTITY_SARCAT_DEFAULT_ID_NOT_FOUND":"No s'ha trobat l'ID centre per defecte de l'entitat",
        "OU_ESPECIFIC_NOT_FOUND":"No s'ha trobat la unitat organitzativa (UO) específica",
        "ENTITY_SARCAT_OU_ESPECIFIC_NOT_FOUND":"La unitat organitzativa (UO) no té l'ID centre configurat",
        "OU_GENERIC_NOT_FOUND":"No s'ha trobat la unitat organitzativa (UO) principal",
        "ENTITY_SARCAT_OU_GENERIC_NOT_FOUND":"La unitat organitzativa (UO) principal no té l'ID centre configurat",
        "ADD_DATA_PGEN_MUX_TRANSACTION_REQUEST_REASON_FIELD_NOT_FOUND":"No s'han trobat el camp 'Motiu' en el formulari",
        "ADD_DATA_PGEN_MUX_TRANSACTION_REQUEST_SECTION_NOT_FOUND":"No s'ha trobat la secció 'sol·licitud' del formulari en la transacció del MUX",
        "UE_USER_ENTITY_ALREADY_EXISTS":"L'usuari ja existeix",
        "UE_USER_ENTITY_NOT_FOUND":"No s'ha trobat l'usuari",
        "UED_USER_ENTITY_NOT_FOUND":"No s'ha trobat l'usuari",
        "UED_ENTITY_BAD_LOCATED":"Usuari mal localitzat",
        "UED_USER_NOT_FOUND":"No s'ha trobat l'usuari",
        "UED_IDENTIFIER_ALREADY_EXISTS":"Ja existeix un usuari amb aquest identificador",
        "UE_AUTO_REMOVE_FORBIDEN":"No pots eliminar-te a tu mateix",
        "LOGGED_ENTITY_ID_NOT_FOUND": "S'han trobat problemes amb l'entitat en la qual has iniciat sessió",
	    "PROMOTER_ENTITY_ID_NOT_FOUND": "No existeix l'entitat emissora",
	    "SERVICE_CODE_NOT_FOUND": "No s'ha trobat el codi del servei",
	    "PROCEDURE_CODE_NOT_FOUND": "No s'ha trobat el codi del tràmit",
	    "SERVICE_INSTANCE_NOT_FOUND": "No s'ha trobat l'expedient",
	    "SERVICE_DETAIL_NOT_FOUND": "No s'ha trobat la URL d'accés al servei",
	    "PROCEDURE_DETAIL_NOT_FOUND": "No s'ha trobat la URL d'accés al tràmit",
	    "REQUEST_E2_CONNECTOR_ERROR": "No s'ha pogut resoldre la URL de l'aplicació externa",
	    "SERVICE_DETAIL_REQUEST_ERROR": "No s'ha pogut resoldre la URL d'accés al servei",
	    "PROCEDURE_DETAIL_REQUEST_ERROR": "No s'ha pogut resoldre la URL d'accés al tràmit",
	    "SERVICE_INSTANCE_NOT_ASSOCIATED_TO_ENTITY_ID": "No tens permisos per accedir a aquest expedient",
	    "SERVICE_PROMOTER_NOT_FOUND": "No s'ha trobat el prestador del servei",
        "RESUME_DELETE_ERROR": "No es pot esborrar l'arxiu resum generat per l'oficina de registre d'aquesta instancia.",
        "AUTO_PGEN_ERROR":"No pots enviar-te una tramesa genèrica",
        "PROMOTER_AND_RECEPTOR_CANT_BE_THE_SAME":"No pots tràmitar tràmits genèrics a tu mateix",
        "IMPERSONATE_ERROR":"Actualment, només et pots impersonar amb gestors de l'entitat",
        "INBOX_NOT_FOUND":"No s'ha trobat la bústia",
        "PROCEDURE_INSTANCE_SIGNER_INFO_EXISTS":"L'usuari té associat/s tràmit/s per signar",
        "SERVICE_INSTANCE_SHARE_EXISTS": "L'usuari té associat/s expedient/s de tramitació",
        "FORM_IS_PROCESSED": "Aquest tràmit ja ha estat enviat i s'està processant. No el tornis a enviar.",
        "NOT_SAME_ENTITY": "Aquest tràmit no pertany a la teva entitat i no el pots tramitar.",
        "ERROR_PROCEDURE_IS_CURRENT_PROCESSING": "Aquest tràmit ja ha estat enviat i s'està processant. No el tornis a enviar.",
        "NO_UUID_FORM_FOUND": null,
        "DOWNLOAD_DESAL_FILE_ERROR_OFFICE_REGISTRY": null,
        "ERROR_CALLING_OVER_CONSULTA": null,
        "ERROR_STORING_SOURCE": null,
        "JSON_MALFORMED_TO_E2": null,
        "PCI_GENERIC_ERROR": "Torna-ho a provar d'aquí a un moment. Si persisteix, contacta amb Suport."
    };

    export function onResponse(data: { ok: boolean, messageCode: string },  snack: MatSnackBar, onOK?: () => void, onKo?: (msg: string, code: string) => void) {
        if (!data.ok) {
            let msg = null
            let code = ""

            if (data.messageCode != null) {
                msg = errorsMsg[data.messageCode]
                code = data.messageCode
            }

            if (msg == null) {
                msg = `Torna-ho a provar d'aquí a un moment. Si persisteix, contacta amb Suport.`
            }
            
            if (onKo) {
                onKo(msg, code)
                return
            }

            snack.open(msg, "Entès")
            return
        }
        
        if (onOK) {
            onOK()
        }
    }

    export function getErrorByType(type: string) {
        let error = errorsMsg[type];
        if (error == null) {
            return `Torna-ho a provar d'aquí a un moment. Si persisteix, contacta amb Suport.`;
        }
        return error;
    }

}
